import { api, ApiRoutes } from './ApiService'
import { Font } from '../types/Font'

export const FontService = {
    async getAllFonts(): Promise<Font[]> {
        try {
            const response = await api.get(ApiRoutes.FONTS)
            return response.data?.data || []
        } catch (error) {
            console.error('Failed to fetch fonts:', error)
            return []
        }
    },
}

